import React, { useState, useEffect, useRef } from "react";
import * as _ from "lodash";
import "../../Invs/AFReadyDisigen/invoiceprint.css"
import { stylePadding, stylePaddingFooter, stylePaddingHead, WaterMarkName } from "../../Invs/ShareFunctionsPrint";
import HeaderA from "./A4/HeaderA";
import BodyA, { TotalsAccounts } from "./A4/BodyA";
import FooterAC from "./A4/FooterAC";
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import AccountingRPTTableItems, { groupTransactions } from "../../../comps/Accounts/BackEnd/AccountingRPT/accountingRPTTableItems";
import BodyItems from "./A4/BodyItems";
import SubRowsAccounts from "./A4/SubRows";

function HeadersNew(props) {
    const { found, infoData } = props;
    return (
        <div style={stylePaddingHead}>
            <HeaderA found={found} infoData={infoData} />
        </div>
    );
}
function BodyPrint(props) {
    const { chunk, isLast, infoData } = props;
    return (
        <div style={stylePadding}>
            {infoData?.typePrint === 3 ?
                <BodyItems
                    {...{
                        data: chunk ? groupTransactions(chunk) : [],isLast,infoData
                    }}
                />
                : <BodyA
                    data={chunk ?? []}
                    isLast={isLast}
                    infoData={infoData}
                />}
        </div>
    );
}

function Footers(props) {
    const { found } = props;
    return (
        <div className="footerview" style={stylePaddingFooter}>
            <FooterAC found={found} />
        </div>
    );
}

function NotesFooters(props) {
    const { found } = props;
    return (
        <div style={stylePadding}>
            <Grid xs={12} style={{ fontFamily: "Amiri-Regular", fontWeight: "bold", padding: "0px" }}>
                <div>{found?.MailBox}</div>
            </Grid>
        </div>
    );
}
function RevAccountsCon(props) {
    const { info, dataAccounts, typePrint } = props;
    const headerRef = useRef(null);
    const footerRef = useRef(null);
    const totalsRef = useRef(null);
    const notesRef = useRef(null);
    const rowRefs = useRef([]);
    const [pages, setPages] = useState([]);


    useEffect(() => {
        const calcutepages = async () => {
            if (document.fonts) await document.fonts.ready;
            const PAGE_HEIGHT = 1120;
            const HEADER1 = headerRef.current?.offsetHeight || 0;
            const FOOTER1 = footerRef.current?.offsetHeight || 0;
            const TOTALSR = totalsRef.current?.offsetHeight || 0;
            const NOTESR = notesRef.current?.offsetHeight || 0;
            const heights = rowRefs.current.map(el => el?.offsetHeight || 0);
            let Others = dataAccounts.typePrint === 3 ? 500 : 0;

            let maxHightsAll = PAGE_HEIGHT - (HEADER1 + FOOTER1);
            const max_HeightFirst = PAGE_HEIGHT - (HEADER1 + FOOTER1);
            const max_HeightOnther = PAGE_HEIGHT - (FOOTER1);
            let pageInvoice = [];
            let currentPage = [];
            let currentHeight = 0;

            dataAccounts.data.forEach((item, i) => {
                const rowHieght = heights[i];
                maxHightsAll = pageInvoice.length === 0 ? max_HeightFirst : max_HeightOnther;
                if (currentHeight + rowHieght > maxHightsAll) {
                    pageInvoice.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                currentPage.push(item);
                currentHeight += rowHieght;
            });

            if (currentHeight + TOTALSR + NOTESR > maxHightsAll) {
                pageInvoice.push(currentPage);
                pageInvoice.push([]);
            } else {
                pageInvoice.push(currentPage);
            }
            setPages(pageInvoice);
        };
        calcutepages();
    }, [dataAccounts]);

    
    return (
        <>
            <div className="measurecon" >
                <div ref={headerRef}>
                    <HeadersNew found={info} infoData={dataAccounts} />
                </div>

                {dataAccounts.typePrint === 3 ?
                    <>  {groupTransactions(dataAccounts.data).map((item, i) => (
                        <div key={i}
                            ref={(el) => (rowRefs.current[i] = el)}
                            className="measurerowAcc"
                        >
                            {item.items.length>0?<SubRowsAccounts row={item} />:item.notes}
                            

                        </div>))}</> :
                    <>
                        {dataAccounts.data.map((item, i) => (

                            <div key={i}
                                ref={(el) => (rowRefs.current[i] = el)}
                                className="measurerowAcc"
                            >
                                {item.notes}

                            </div>
                        ))}
                    </>}



                <div ref={totalsRef}>
                    {<TotalsAccounts infoData={dataAccounts} />}
                </div>
                <div ref={notesRef}>
                    {<NotesFooters found={info} />}
                </div>
                <div ref={footerRef}>
                    <Footers found={info} />
                </div>
            </div>
            <div className="invoicepreview">
                {pages.map((page, i) => (
                    <div className="pageinv" key={i}>
                        <WaterMarkName found={info} />
                        <div className="contentview">
                            {i == 0 && (
                                <HeadersNew found={info} infoData={dataAccounts} />
                            )}
                            <BodyPrint chunk={page ?? []} isLast={i == pages.length - 1} infoData={dataAccounts} />
                            {i == pages.length - 1 && <NotesFooters found={info} />}
                        </div>
                        <Footers found={info} />
                    </div>
                ))}
            </div>
        </>
    );
}
export default RevAccountsCon;
